import { useEffect } from "react";
import { toast } from "sonner";
import { setMuted, isMuted, stopAlarm } from "./audio";

const isTyping = (el) => el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || el.isContentEditable);

// Press M (outside text fields) to toggle monitor audio. onChange receives the new muted state.
export function useMuteHotkey(onChange) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "m" && e.key !== "M") return;
      if (e.metaKey || e.ctrlKey || e.altKey || isTyping(e.target)) return;
      const next = !isMuted();
      setMuted(next);
      if (next) stopAlarm();
      onChange?.(next);
      toast(next ? "Monitor audio muted" : "Monitor audio on", { description: "Press M to toggle", duration: 1200 });
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onChange]);
}
